import React, { useState } from "react";
import StatelessTable from "../../../../common/components/elements/StatelessTable";
import I18n from "i18n-js";
import Dropdown from "../../../../common/components/elements/Dropdown";
import { array, func, shape } from "prop-types";
import { connect } from "react-redux";
import { markAnalysisAsViewed as markAnalysisAsViewedAction } from "../../../../analysis/actions/analysisActions";
import { getLang, translateNomenclature } from "../../../../common/utils/langUtils";

InstallationAnalysesList.propTypes = {
  auth: shape().isRequired,
  analyses: array,
  markAnalysisAsViewed: func.isRequired,
};

function InstallationAnalysesList({ auth, analyses, markAnalysisAsViewed }) {
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <StatelessTable
      className=""
      data={analyses}
      pagination={analyses?.length > 5 ? true : false}
      perPage={5}
      currentPage={currentPage}
      onPageChanged={(newPage) => {
        setCurrentPage(newPage);
      }}
      headData={[
        "",
        I18n.t("pages.installations.view.analyses.creation:label"),
        I18n.t("pages.installations.view.analyses.number:label"),
        I18n.t("pages.installations.view.analyses.type:label"),
        I18n.t("pages.installations.view.analyses.status:label"),
        I18n.t("pages.installations.view.analyses.result_status:label"),
        I18n.t("pages.installations.view.analyses.documents:label"),
      ]}
      rowData={({ uuid, kitBarcode, type, status, resultStatus, createdAt, hasResultToView, pdfUrl }) => {
        const typeLabel = type
          ? translateNomenclature(type, "designation", auth.lang)
          : I18n.t("common.unknown");

        const statusLabel = status
          ? translateNomenclature(status, "designation", auth.lang)
          : I18n.t("common.unknown");

        const resultStatusLabel = resultStatus
          ? translateNomenclature(resultStatus, "designation", auth.lang)
          : '-';

        return [
          hasResultToView ? (
            <div className="analysis-view-indicator">
              <span className="analysis-view-indicator-dot" />
            </div>
          ) : null,
          new Date(createdAt).toLocaleDateString(getLang()),
          kitBarcode,
          typeLabel,
          statusLabel,
          resultStatusLabel,
          pdfUrl && (
            <Dropdown
              label={`1 ${I18n.t("pages.analysis.list.head.document")}`}
            >
              <a href={pdfUrl} target="blank" onClick={() => {
                if (hasResultToView) {
                  markAnalysisAsViewed(uuid);
                }
              }}>
                {I18n.t(`pages.analysis.list.document.analysis`)}
              </a>
            </Dropdown>
          ),
        ];
      }}
      getRowClasses={row => row.hasResultToView ? ["table-highlight"] : []}
    />
  );
}

const matchStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  markAnalysisAsViewed: (uuid) => dispatch(markAnalysisAsViewedAction(uuid)),
});

export default connect(matchStateToProps, mapDispatchToProps)(InstallationAnalysesList);
